import { Play, ArrowUpRight } from "lucide-react";
import { useT } from "@/context/LangContext";
import { TIKTOK_VIDEOS, TIKTOK_PROFILE_URL, TIKTOK_HANDLE } from "@/constants/tiktok";
import { TikTokGlyph as TikTokIcon } from "@/components/SocialIcons";

export default function TikTokSection() {
  const t = useT();
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
        <div>
          <p className="kicker inline-flex items-center gap-2">
            <TikTokIcon size={14} /> {t("tiktok.kicker")}
          </p>
          <h2 className="text-4xl lg:text-5xl font-display font-black mt-4 max-w-2xl">
            {t("tiktok.title")}
          </h2>
          <p className="text-[var(--ink-soft)] mt-3 max-w-lg">{t("tiktok.desc")}</p>
        </div>
        <a
          href={TIKTOK_PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-outline self-start md:self-end shrink-0"
          data-testid="tiktok-follow-btn"
        >
          <TikTokIcon size={16} /> {TIKTOK_HANDLE}
        </a>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {TIKTOK_VIDEOS.map((v, i) => (
          <a
            key={v.id}
            href={v.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative block overflow-hidden rounded-lg aspect-[9/16] bg-black"
            data-testid={`tiktok-video-${v.id}`}
          >
            <img
              src={v.cover}
              alt=""
              className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-500"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/80" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-14 h-14 rounded-full bg-white/95 backdrop-blur flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
                <Play size={22} className="text-[var(--accent)] ml-1" fill="currentColor" />
              </div>
            </div>
            <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2 py-1 rounded-full bg-black/70 backdrop-blur text-white text-[10px] font-bold uppercase tracking-widest">
              <TikTokIcon size={11} /> TikTok
            </div>
            <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between text-white">
              <p className="text-xs font-bold">{t("tiktok.video")} {i + 1}</p>
              <ArrowUpRight size={14} className="opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
